export const filtersOptions = {
  status(value) {
    switch (value) {
      case 'I':
        return 'Invited';
      case 'P':
        return 'Public';
      case 'H':
        return 'Hidden';
      case 'S':
        return 'Searchable';
      case 'N':
        return 'Hidden';
      default:
        return 'Invited';
    }
  },
  circleClass(value) {
    switch (value) {
      case 'H':
        return 'fc-medium';
      case 'N':
        return 'fc-medium';
      case 'P':
        return 'fc-green';
      case 'S':
        return 'fc-green';
      default:
        return 'fc-light';
    }
  },
  tier(value) {
    switch (value) {
      case '':
      case null:
      case undefined:
      case 'default':
        return '-';
      default:
        return value;
    }
  },
};
